/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Tool call feature payload.
 */
export type HookToolCallData = {
  /**
   * Tool execution duration in milliseconds, when reported.
   */
  durationMs?: number | undefined;
  /**
   * Tool error payload.
   */
  error?: any | undefined;
  /**
   * Provider tool call identifier.
   */
  id?: string | undefined;
  /**
   * Tool input payload.
   */
  input?: any | undefined;
  /**
   * Whether the failure was caused by user interruption.
   */
  isInterrupt?: boolean | undefined;
  /**
   * Tool name.
   */
  name?: string | undefined;
  /**
   * Tool output payload.
   */
  output?: any | undefined;
  /**
   * Permission type requested by the agent, when applicable.
   */
  permissionType?: string | undefined;
  /**
   * Provider-reported tool call status, when available.
   */
  status?: string | undefined;
};

/** @internal */
export type HookToolCallData$Outbound = {
  duration_ms?: number | undefined;
  error?: any | undefined;
  id?: string | undefined;
  input?: any | undefined;
  is_interrupt?: boolean | undefined;
  name?: string | undefined;
  output?: any | undefined;
  permission_type?: string | undefined;
  status?: string | undefined;
};

/** @internal */
export const HookToolCallData$outboundSchema: z.ZodMiniType<
  HookToolCallData$Outbound,
  HookToolCallData
> = z.pipe(
  z.object({
    durationMs: z.optional(z.number()),
    error: z.optional(z.any()),
    id: z.optional(z.string()),
    input: z.optional(z.any()),
    isInterrupt: z.optional(z.boolean()),
    name: z.optional(z.string()),
    output: z.optional(z.any()),
    permissionType: z.optional(z.string()),
    status: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      durationMs: "duration_ms",
      isInterrupt: "is_interrupt",
      permissionType: "permission_type",
    });
  }),
);

export function hookToolCallDataToJSON(
  hookToolCallData: HookToolCallData,
): string {
  return JSON.stringify(
    HookToolCallData$outboundSchema.parse(hookToolCallData),
  );
}
